import Layout from "../../api/model/snapshots/layers/Layout";

function equals(layout: Layout, otherLayout: Layout) {
    return (
        layout.direction === otherLayout.direction &&
        layout.distribution === otherLayout.distribution &&
        layout.itemAlignment === otherLayout.itemAlignment &&
        layout.gap === otherLayout.gap &&
        layout.padding?.top === otherLayout.padding?.top &&
        layout.padding?.bottom === otherLayout.padding?.bottom &&
        layout.padding?.right === otherLayout.padding?.right &&
        layout.padding?.left === otherLayout.padding?.left
    );
}

export { equals };
